module.exports = __webpack_public_path__ + "img/03.68e4266a.jpg";